import { render } from "./ToastV2Element.vue?vue&type=template&id=21746055"
import script from "./ToastV2Element.vue?vue&type=script&lang=js"
export * from "./ToastV2Element.vue?vue&type=script&lang=js"

import "./ToastV2Element.vue?vue&type=style&index=0&id=21746055&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__